import loadable from '@loadable/component';
import { type FunctionComponent } from 'react';
import { FEATURE_FLAGS } from '../../constants/general';
import { useSiteViewPreference } from '../../hooks/apollo/employee/employee.hooks';
import { useFeatures } from '../../hooks/features/features.hooks';
import { doesWindowExist } from '../../utils/dom/dom.utils';

const loadableInternalChat = loadable(() => import(/* webpackChunkName: "internal-chat" */ './internal-chat/internal-chat.component'), {
	resolveComponent: ({ InternalChat }) => InternalChat
});

const loadableLiveChat = loadable(() => import(/* webpackChunkName: "live-chat" */ './live-chat/live-chat.component'), {
	resolveComponent: ({ LiveChat }) => LiveChat
});

const loadableEnhancedLiveChat = loadable(() => import(/* webpackChunkName: "enh-live-chat" */ './enh-live-chat/enh-live-chat.component'), {
	resolveComponent: ({ EnhancedLiveChat }) => EnhancedLiveChat
});

export const LoadableChat: FunctionComponent = () => {
	const { showAsEmployee } = useSiteViewPreference();
	const [isInternalChatEnabled, isLiveChatEnabled, isEnhancedLiveChatEnabled] = useFeatures<[boolean, boolean, boolean]>(
		[FEATURE_FLAGS.INTERNAL_CHAT, FEATURE_FLAGS.LIVE_CHAT, FEATURE_FLAGS.ENHANCED_LIVE_CHAT],
		{ isSiteWide: true }
	);
	let LoadedChat: React.ComponentType | null = null;

	if (doesWindowExist()) {
		if (showAsEmployee && isInternalChatEnabled) {
			LoadedChat = loadableInternalChat;
		} else if (isEnhancedLiveChatEnabled) {
			LoadedChat = loadableEnhancedLiveChat;
		} else if (isLiveChatEnabled) {
			LoadedChat = loadableLiveChat;
		}
	}

	return LoadedChat ? <LoadedChat /> : null;
};
